import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  useGetHostGroupQuery,
  useGetHostGroupMessagesQuery,
  useDeleteHostGroupMessageMutation,
} from '../../api/groupApi';
import useGroupMessagesSocket from '../../hooks/useGroupMessagesSocket';
import { selectCurrentUser } from '../../slices/authSlice';
import EntityFormPage from '../../components/EntityFormPage/EntityFormPage';
import GroupMessagesList from '../../components/GroupMessagesList/GroupMessagesList';

export default function GroupMessagesPage() {
  const { id } = useParams();
  const currentUser = useSelector(selectCurrentUser);
  const { data: group } = useGetHostGroupQuery(id);
  const { data: messages, isLoading } = useGetHostGroupMessagesQuery(id, { pollingInterval: 60000 });
  useGroupMessagesSocket(id);
  const [deleteMessage] = useDeleteHostGroupMessageMutation();
  const isBroadcast = group ? !group.broadcast : true;

  return (
    <EntityFormPage
      title={`Messages${group ? ` — ${group.name}` : ''}`}
      backTo="/host/giveaways"
      wide={isBroadcast}
      full={!isBroadcast}
      fullHeight
    >
      <GroupMessagesList
        messages={messages}
        isLoading={isLoading}
        currentUserId={currentUser?.id}
        currentUserRole={currentUser?.role}
        onDelete={(messageId) => deleteMessage({ groupId: id, messageId }).unwrap()}
        isBroadcast={isBroadcast}
        groupName={group?.name}
      />
    </EntityFormPage>
  );
}
